module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5r1r2r-5a0180b2eb2cb09338f5b8ab89916bfb.svg";